const baseUrl = process.env.REACT_APP_BASE_URL;
const webBaseUrl = process.env.REACT_APP_WEB_BASE_URL;
const googleUserInfoUrl = process.env.REACT_APP_GOOGLE_USER_INFO_URL;

export { baseUrl, webBaseUrl, googleUserInfoUrl };
